import { Link } from 'react-router-dom';
import { latestComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestUpdates() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm mt-2">新鲜出炉的热门连载</p>
          </div>
          <Link
            to="/category/fantasy"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="normal" />
          ))}
        </div>
      </div>
    </section>
  );
}